<template>
  <div
    class="grid grid-cols-2 items-center py-1"
    :class="{ 'hover:bg-gray-100': !disabled, 'bg-gray-100 pointer-events-none': disabled }"
  >
    <slot v-bind="{ click }"></slot>
  </div>
</template>

<script>
import { watch } from 'vue'

export default {
  props: ['team', 'public', 'adminTeamId', 'partnerTeamId'],
  data() {
    return {
      disabled: false,
    }
  },
  methods: {
    click($val) {
      let prefix = this.public ? 'frm-publicUserForm-publicUserForm-teams-' : 'frm-userForm-userForm-teams-'
      if ($val == this.$formValues[prefix + this.team]) {
        this.$formValues[prefix + this.team + ':change'] = 0
      } else {
        this.$formValues[prefix + this.team + ':change'] = $val
      }
    },
  },
  mounted() {
    if (this.team == this.adminTeamId) {
      if (!this.$formValues['frm-userForm-userForm-owner']) {
        watch(() => this.$formValues['frm-userForm-userForm-admin'], (val) => {
          if (val) {
            this.disabled = true
            this.$formValues['frm-userForm-userForm-teams-' + this.team + ':change'] = 5
          } else {
            this.disabled = false
            this.$formValues['frm-userForm-userForm-teams-' + this.team + ':change'] = 0
          }
        })

        if (this.$formValues['frm-userForm-userForm-admin']) {
          this.disabled = true
          this.$formValues['frm-userForm-userForm-teams-' + this.team + ':change'] = 5
        }
      } else {
        this.disabled = true
        this.$formValues['frm-userForm-userForm-teams-' + this.team + ':change'] = 5
      }
    }

    if (this.team == this.partnerTeamId) {
      this.disabled = true
    }
  }
}
</script>